interface CommentCardProps {
  nickname: string;
  username: string;
  avatar: string;
  content: string;
  likes: number;
}

export default function CommentCard({ nickname, username, avatar, content, likes }: CommentCardProps) {
  return (
    <div className="bg-background-50 rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 rounded-full overflow-hidden bg-accent-100">
          <img
            src={avatar}
            alt={nickname}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div>
          <p className="text-sm font-semibold text-foreground-900">{nickname}</p>
          <p className="text-xs text-foreground-400">{username}</p>
        </div>
      </div>
      <div className="relative">
        <span className="absolute -top-1 -left-1 text-2xl text-primary-200 leading-none select-none">&ldquo;</span>
        <p className="text-sm text-foreground-700 leading-relaxed pl-3 pr-1">
          {content}
        </p>
        <span className="block text-right text-2xl text-primary-200 leading-none select-none mt-1">&rdquo;</span>
      </div>
      <div className="flex items-center gap-1 mt-3 pt-3 border-t border-background-200">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-heart-line text-sm text-foreground-400"></i>
        </div>
        <span className="text-xs text-foreground-400">{likes}</span>
      </div>
    </div>
  );
}